import { Children, isValidElement } from 'react';
/**
 * Get list children array.
 *
 * @author Mikhail Siutsou
 * @param {ReactNode | ReactNode[]) => JSX.Element)} children children list.
 * @param {string} name children name.
 * @return {(ReactChild | ReactFragment | ReactPortal)[] | null | undefined} return list children array.
 */

function getListChildren(children, name) {
  return Children.map(children, function (child) {
    var childElement = child;
    return childElement.type.displayName === name ? childElement : undefined;
  });
}
/**
 * Get valid children .
 *
 * @author Mikhail Siutsou
 * @param {type: FC<T>} type children type.
 * @return {boolean} is child valid.
 */


function getValidChild(type) {
  return function (child) {
    return /*#__PURE__*/isValidElement(child) ? child.type === type : false;
  };
}

export { getListChildren, getValidChild };